import { Badge, Tooltip } from '@mantine/core'
import type { KbStatus } from '@/api/whatsapi'

const KB_STATUS_CONFIG: Record<KbStatus, { color: string; label: string }> = {
  pending:    { color: 'yellow', label: 'Pendente' },
  processing: { color: 'yellow', label: 'Processando' },
  ready:      { color: 'green',  label: 'Pronto' },
  failed:     { color: 'red',    label: 'Falhou' },
}

interface KbStatusBadgeProps {
  status: KbStatus | string
  error?: string | null
  size?: 'xs' | 'sm' | 'md'
}

export function KbStatusBadge({ status, error, size = 'sm' }: KbStatusBadgeProps) {
  const config = KB_STATUS_CONFIG[status as KbStatus] ?? { color: 'gray', label: status }
  const badge = (
    <Badge color={config.color} variant="light" size={size} aria-label={`Status: ${config.label}`}>
      {config.label}
    </Badge>
  )
  if (status === 'failed' && error) {
    return <Tooltip label={error} multiline w={260}>{badge}</Tooltip>
  }
  return badge
}
